import React from 'react';

import AbortedIcon from '../assets/status/test_details_status_aborted.svg';
import CancelledIcon from '../assets/status/test_details_status_cancelled.svg';
import ErrorIcon from '../assets/status/test_details_status_error.svg';
import LambdaIcon from '../assets/status/test_details_status_lambda_error.svg';
import PassedIcon from '../assets/status/test_details_status_passed.svg';
import TimeoutIcon from '../assets/status/test_details_status_timeout.svg';
import QueuedIcon from '../assets/status/test_details_status_queued.svg';
import StoppedIcon from '../assets/status/test_details_status_stopped.svg';
import FailedIcon from '../assets/status/test_details_status_failed.svg';
import InitiatedIcon from '../assets/status/test_details_status_initiated.svg';
import SkippedIcon from '../assets/status/test_details_status_skipped.svg';
import IgnoredIcon from '../assets/status/test_details_status_ignored.svg';
import UnknownIcon from '../assets/status/test_details_status_unknown.svg';

// elegant icons
import Passed from '../assets/elegantStatus/passed';
import Failed from '../assets/elegantStatus/failed';
import Completed from '../assets/elegantStatus/completed';
import Skipped from '../assets/elegantStatus/skipped';
import Stopped from '../assets/elegantStatus/stopped';
import Aborted from '../assets/elegantStatus/aborted';
import Cancelled from '../assets/elegantStatus/cancelled';
import Error from '../assets/elegantStatus/error';
import LambdaError from '../assets/elegantStatus/lambdaError';
import QueueTimeout from '../assets/elegantStatus/queueTimeout';
import IdleTimeout from '../assets/elegantStatus/idleTimeout';
import Queued from '../assets/elegantStatus/queued';
import Initiated from '../assets/elegantStatus/initiated';
import Ignored from '../assets/elegantStatus/ignored';
import Unknown from '../assets/elegantStatus/unknown';

import { TestStatusMap, TestStatusNameMap } from '../constants/test.js';

export const getStatusIconAndClassPrefix = (status) => {
  let statusIconName;
  let statusIcon;
  let statusElegantIcon;
  let statusName = TestStatusNameMap[status];
  let classPrefixToAdd = '';
  switch (status) {
    case TestStatusMap.PASSED:
      classPrefixToAdd = TestStatusMap.PASSED;
      statusIconName = PassedIcon;
      statusElegantIcon = <Passed />;
      break;
    case TestStatusMap.COMPLETED:
      classPrefixToAdd = TestStatusMap.COMPLETED;
      statusIconName = PassedIcon;
      statusElegantIcon = <Completed />;
      break;
    case TestStatusMap.SKIPPED:
      classPrefixToAdd = TestStatusMap.SKIPPED;
      statusIconName = SkippedIcon;
      statusElegantIcon = <Skipped />;
      break;
    case TestStatusMap.STOPPED:
      classPrefixToAdd = TestStatusMap.STOPPED;
      statusIconName = StoppedIcon;
      statusElegantIcon = <Stopped />;
      break;
    case TestStatusMap.ABORTED:
      classPrefixToAdd = TestStatusMap.STOPPED;
      statusIconName = AbortedIcon;
      statusElegantIcon = <Aborted />;
      break;
    case TestStatusMap.CANCELLED:
      classPrefixToAdd = TestStatusMap.CANCELLED;
      statusIconName = CancelledIcon;
      statusElegantIcon = <Cancelled />;
      break;
    case TestStatusMap.ERROR:
      classPrefixToAdd = TestStatusMap.ERROR;
      statusIconName = ErrorIcon;
      statusElegantIcon = <Error />;
      break;

    case TestStatusMap.LAMBDA_ERROR:
      classPrefixToAdd = 'lambdaError';
      statusIconName = LambdaIcon;
      statusElegantIcon = <LambdaError />;
      break;
    case TestStatusMap.FAILED:
      classPrefixToAdd = TestStatusMap.FAILED;
      statusIconName = FailedIcon;
      statusElegantIcon = <Failed />;
      break;
    case TestStatusMap.QUEUE_TIMEOUT:
      classPrefixToAdd = TestStatusMap.QUEUE_TIMEOUT;
      statusIconName = TimeoutIcon;
      statusElegantIcon = <QueueTimeout />;
      break;
    case TestStatusMap.IDLE_TIMEOUT:
    case TestStatusMap.PQUEUED:
    case TestStatusMap.TIMEOUT:
      classPrefixToAdd = TestStatusMap.IDLE_TIMEOUT;
      statusIconName = TimeoutIcon;
      statusName = TestStatusNameMap[TestStatusMap.IDLE_TIMEOUT];
      statusElegantIcon = <IdleTimeout />;
      break;
    case TestStatusMap.QUEUED:
      classPrefixToAdd = TestStatusMap.QUEUED;
      statusIconName = QueuedIcon;
      statusElegantIcon = <Queued />;
      break;
    case TestStatusMap.RUNNING:
      classPrefixToAdd = TestStatusMap.RUNNING;
      break;
    case TestStatusMap.INITIATED:
      classPrefixToAdd = TestStatusMap.INITIATED;
      statusIconName = InitiatedIcon;
      statusElegantIcon = <Initiated />;
      break;
    case TestStatusMap.IGNORED:
      classPrefixToAdd = TestStatusMap.IGNORED;
      statusIconName = IgnoredIcon;
      statusElegantIcon = <Ignored />;
      break;
    default:
      classPrefixToAdd = TestStatusMap.UNKNOWN;
      statusIconName = UnknownIcon;
      statusElegantIcon = <Unknown />;
  }

  return {
    statusIcon,
    statusIconName,
    classPrefixToAdd,
    statusName,
    statusElegantIcon,
  };
};
